import { BrowserModule, Title } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Injectable } from '@angular/core';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { ConfigComponent } from './widgets/config/config.component';
import { FooterComponent } from './widgets/footer/footer.component';
import { HeaderComponent } from './widgets/header/header.component';
import { StatusbarComponent } from './widgets/simulator/menu/statusbar/statusbar.component';
import { SimulatorComponent } from './widgets/simulator/simulator.component';
import { ScreenComponent } from './widgets/simulator/screen/screen.component';
import { DashboardComponent } from './widgets/simulator/screen/dashboard/dashboard.component';
import { DefaultscreenComponent } from './widgets/simulator/screen/defaultscreen/defaultscreen.component';
import { IconbarComponent } from './widgets/simulator/menu/statusbar/iconbar/iconbar.component';
import { IdleComponent } from './widgets/simulator/screen/idle/idle.component';
import { DebugcontrolsComponent } from './widgets/debug/debugcontrols/debugcontrols.component';
import { QuickvetoComponent } from './widgets/simulator/screen/quickveto/quickveto.component';
import { QuickactionComponent } from './widgets/simulator/screen/quickaction/quickaction.component';
import { WaterpressureComponent } from './widgets/simulator/screen/waterpressure/waterpressure.component';
import { SettingsvalueComponent } from './widgets/simulator/screen/settingsvalue/settingsvalue.component';
import { ToastComponent } from './widgets/simulator/screen/toast/toast.component';
import { HelpComponent } from './widgets/simulator/screen/help/help.component';
import { MenuComponent } from './widgets/simulator/screen/menu/menu.component';
import { LoadinganimationComponent } from './widgets/simulator/screen/loadinganimation/loadinganimation.component';
import { TimesetComponent } from './widgets/simulator/screen/timeset/timeset.component';
import { ListComponent } from './widgets/simulator/screen/list/list.component';
import { SetvalueComponent } from './widgets/simulator/screen/setvalue/setvalue.component';
import { TextinputComponent } from './widgets/helpers/textinput/textinput.component';
import { EnabledNodesPipe } from './pipes/enabled-nodes.pipe';
import { WeekOverviewComponent } from './widgets/simulator/screen/week-overview/week-overview.component';
import { DayOverviewComponent } from './widgets/helpers/day-overview/day-overview.component';
import { DayPlannerOverviewComponent } from './widgets/simulator/screen/day-planner-overview/day-planner-overview.component';
import { DayPlannerComponent } from './widgets/simulator/screen/day-planner/day-planner.component';
import { TextComponent } from './widgets/simulator/screen/text/text.component';
import { ControlShowcaseComponent } from './widgets/simulator/screen/control-showcase/control-showcase.component';
import { TextdisplayComponent } from './widgets/helpers/textdisplay/textdisplay.component';
import { MenuShowcaseComponent } from './widgets/simulator/screen/menu-showcase/menu-showcase.component';
import { ZeitwahlComponent } from './widgets/simulator/screen/zeitwahl/zeitwahl.component';
import { TimeframeDisplayComponent } from './widgets/helpers/timeframe-display/timeframe-display.component';
import { HelpScreenComponent } from './widgets/simulator/screen/help-screen/help-screen.component';
import { SplashComponent } from './widgets/helpers/splash/splash.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ShowValueComponent } from './widgets/simulator/screen/show-value/show-value.component';
import { PwaInstallerComponent }  from './widgets/pwa-installer/pwa-installer.component';
export class MyHammerConfig extends HammerGestureConfig  {
  overrides = <any>{
    'swipe': {velocity: 0.4, threshold: 20}, // override default settings
    'pan': {velocity: 0.5, threshold: 1} // override default settings
  }
}
@NgModule({
  declarations: [
    AppComponent,
    ConfigComponent,
    FooterComponent,
    HeaderComponent,
    SimulatorComponent,
    ScreenComponent,
    DashboardComponent,
    StatusbarComponent,
    DefaultscreenComponent,
    IconbarComponent,
    IdleComponent,
    DebugcontrolsComponent,
    QuickvetoComponent,
    QuickactionComponent,
    WaterpressureComponent,
    SettingsvalueComponent,
    ToastComponent,
    HelpComponent,
    MenuComponent,
    LoadinganimationComponent,
    TimesetComponent,
    ListComponent,
    SetvalueComponent,
    TextinputComponent,
    EnabledNodesPipe,
    WeekOverviewComponent,
    DayPlannerOverviewComponent,
    DayPlannerComponent,
    DayOverviewComponent,
    TextComponent,
    ControlShowcaseComponent,
    TextdisplayComponent,
    MenuShowcaseComponent,
    ZeitwahlComponent,
    TimeframeDisplayComponent,
    HelpScreenComponent,
    SplashComponent,
    ShowValueComponent,
    PwaInstallerComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    //ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production })
    //NotifierModule
  ],
  entryComponents:[
    DashboardComponent,
    StatusbarComponent,
    DefaultscreenComponent,
    IconbarComponent,
    IdleComponent,
    DebugcontrolsComponent,
    QuickvetoComponent,
    QuickactionComponent,
    WaterpressureComponent,
    SettingsvalueComponent,
    ToastComponent,
    HelpComponent,
    MenuComponent,
    LoadinganimationComponent,
    TimesetComponent,
    ListComponent,
    SetvalueComponent,
    WeekOverviewComponent,
    DayOverviewComponent,
    DayPlannerOverviewComponent,
    DayPlannerComponent,
    TextComponent,
    ControlShowcaseComponent,
    MenuShowcaseComponent,
    ZeitwahlComponent,
    HelpScreenComponent,
    SplashComponent,
    ShowValueComponent,
    PwaInstallerComponent,
  ],
  providers: [
      Title,
      EnabledNodesPipe,
      {
          provide: HAMMER_GESTURE_CONFIG, 
          useClass: MyHammerConfig 
      }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
